import { render, staticRenderFns } from "./AlliancePage.vue?vue&type=template&id=404196c2"
import script from "./AlliancePage.vue?vue&type=script&lang=js"
export * from "./AlliancePage.vue?vue&type=script&lang=js"
import style0 from "./AlliancePage.vue?vue&type=style&index=0&id=404196c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports